import { render, staticRenderFns } from "./BibleStudyPage.vue?vue&type=template&id=3bed1434&scoped=true"
import script from "./BibleStudyPage.vue?vue&type=script&lang=js"
export * from "./BibleStudyPage.vue?vue&type=script&lang=js"
import style0 from "./BibleStudyPage.vue?vue&type=style&index=0&id=3bed1434&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bed1434",
  null
  
)

export default component.exports